var map = {
	"./src/basic.js": "ik3R",
	"./src/customer.js": "DJPk",
	"./src/dictionary.js": "eSsJ",
	"./src/login.js": "uTQ5",
	"./src/map.js": "kBOz",
	"./src/memberAmount.js": "sg/U",
	"./src/mobile.js": "rslH",
	"./src/myAddressList.js": "3XiS",
	"./src/order.js": "rEO3",
	"./src/orderConfirm.js": "NrMo",
	"./src/orderList.js": "TauT",
	"./src/pageH5.js": "XvyC",
	"./src/pay.js": "DiaM",
	"./src/serviceArea.js": "NIST",
	"./src/serviceDetail.js": "cbkt",
	"./src/serviceInfo.js": "wDZf",
	"./src/uc.js": "2y3N",
	"./src/userMemberRelation.js": "W/cr",
	"./src/wechat.js": "mCX1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BXAN";


//////////////////
// WEBPACK FOOTER
// ./src/apis \.\/(\w+\/)+\w+\.js
// module id = BXAN
// module chunks = 50